// This constant contains PXT-CMS domainId to USC domain mapping
export const PXT_CMS_DOMAIN_ID_TO_USC_DOMAIN_MAPPING: Record<string, string> = {
  ATP: 'Payroll'
};
